module.exports = __webpack_public_path__ + "assets/icons-misc-move-widget-24-px.adaeda79.svg";